export default {
    name: 'de',
    messages: {
        "alpha": "Dieses Feld darf nur Buchstaben enthalten",
        "alpha_dash": "Feld darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten",
        "alpha_num": "Feld darf nur alphanumerische Zeichen enthalten",
        "alpha_spaces": "Feld darf nur alphanumerische Zeichen und Leerzeichen enthalten",
        "between": "Feld muss zwischen {min} und {max} liegen",
        "email": "Feld muss eine gültige E-Mail-Adresse sein",
        "integer": "Wert muss eine ganze Zahl sein",
        "decimal": "Das Feld darf nur Dezimalzahlen mit {precision} Nachkommastellen enthalten.",
        "length": "Bitte genau {length} Zeichen",
        "max": "Text zu lang.",
        "max_value": "Wert zu groß.",
        "mimes": "Feld muss einen gültigen Dateityp haben",
        "min": "Text zu kurz.",
        "min_value": "Wert zu gering.",
        "numeric": "Feld darf nur Zahlen enthalten",
        "regex": "Das Format ist ungültig",
        "required": "Dies ist ein Pflichtfeld",
        "required_if": "Dies ist ein Pflichtfeld",
        "size": "Datei muss kleiner als {size}KB sein",
        "date": "Dies ist kein gültiges Datum.",
        
    }
};